module.exports = __webpack_public_path__ + "img/td_C3.3.e662ac85.png";